import React from 'react'
import { useSelector } from 'react-redux'
import store from '../../store'
import { toggleProjectListFilterView } from '../../store/actions/FilterView'
import { IconButton, useTheme } from '@mui/material'
import TileIcon from '../icons/TileIcon'
import ListIcon from '../icons/ListIcon'

export default function ViewToggle(props)
{
    const theme = useTheme()
    const projectListFilterView = useSelector((state) => state.filterView.projectListFilterView)

    const changeProjectListFilterView = (filterView) => {
        localStorage.setItem('currentView', filterView)
        store.dispatch(toggleProjectListFilterView(filterView))
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: '76px',
                height: '40px',
                borderRadius: '8px',
                gap: '5px',
                backgroundColor: theme.palette.background.tab
            }}
        >
            <IconButton
                onClick={() => { changeProjectListFilterView('TileView') }}
                style={{
                    height: '32px',
                    width: '32px',
                    borderRadius: '6px',
                    padding: '0px',
                    backgroundColor: projectListFilterView === 'TileView'
                        ? theme.palette.background.button
                        : ''
                }}
            >
                <TileIcon isActive={projectListFilterView === 'TileView'} />
            </IconButton>
            <IconButton
                onClick={() => { changeProjectListFilterView('ListView') }}
                style={{
                    height: '32px',
                    width: '32px',
                    borderRadius: '6px',
                    padding: '0px',
                    backgroundColor: projectListFilterView === 'ListView'
                        ? theme.palette.background.button
                        : ''
                }}
            >
                <ListIcon isActive={projectListFilterView === 'ListView'} />
            </IconButton>
        </div>
    )
}